import * as api from "../Api/index";

export const getAdminStats = () => async (dispatch) => {
  try {
    const { data } = await api.adminStats();
    dispatch({ type: "GET_ALL_ADMINISTRATOR_STATS", payload: data });
  } catch (error) {}
};
